import React, { Component } from "react";
import Helmet from "react-helmet";
import { Provider } from "rebass";
import graphql from "graphql";
import styled from "styled-components";
import MixpanelProvider from "react-mixpanel";
import { mixpanel } from "../../gatsby-browser";

import theme from "../utils/theme";

// import "./all.scss";

type Props = {
  children: React.Node,
  data: {
    site: {
      siteMetadate: {}
    }
  }
};

class TemplateWrapper extends Component<Props> {
  componentDidMount() {
    if (typeof window !== `undefined`) window.PL_disableFacebookSDK = true;
  }

  render() {
    const {
      children,
      data: {
        site: { siteMetadata }
      }
    } = this.props;

    return (
      <Provider theme={theme}>
        <Helmet title="Pipeline" />

        <MixpanelProvider mixpanel={mixpanel}>{children()}</MixpanelProvider>
      </Provider>
    );
  }
}

export default TemplateWrapper;

export const pageQuery = graphql`
  query mQuery {
    site {
      siteMetadata {
        appUrl
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/m.jsx